import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@stratascratch/ui';
import './EditorButtonsLayout.css';
export function EditorButtonsLayout({ children = undefined, className = undefined, }) {
    cn();
    return (_jsx("div", { className: cn('EditorButtonsLayout__container border-(--color-border) flex flex-col gap-x-4 gap-y-2 border-b p-4', className), children: children }));
}
export function EditorButtonsWrapper({ children }) {
    return (_jsx("div", { className: "EditorButtonsLayout__buttons-wrapper flex gap-2", children: children }));
}
//# sourceMappingURL=EditorButtonsLayout.js.map